<template>
	<div class="rounded-sm group-background">
		<v-img
			class="group-background-image"
			:src="(group.background) ? group.background.url : defaultImage"
		></v-img>
		<div v-if="allowToEdit" class="d-flex justify-content-right pt-3 pr-3">
			<v-btn
				elevation="0"
				color="grey lighten-2"
				class="grey--text text--darken-1"
				@click="showBackgroundImageDialog()"
				:disabled="sending"
				style="z-index:1"
			>
				<v-icon class="mr-2">$camera</v-icon>{{ $vuetify.lang.t('$vuetify.views.group.changePicture') }}
			</v-btn>
			<attach-image-dialog
				@selected="setBackgroundImage"
				ref="background-image-dialog"
			/>
		</div>
	</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AttachImageDialog from "@/components/wall/dialogs/AttachImageDialog";

export default {
	name: "GroupBackgroundPicture",
	components: {
		AttachImageDialog
	},
	data() {
		return {
			sending: false,
			defaultImage: require('@/assets/images/group/background.png')
		}
	},
	computed: {
		...mapGetters({
			group: "groups/group",
			user: "auth/user",
		}),
		allowToEdit: function () {
			return this.group.admins.findIndex(item => item.id === this.user.id) > -1
		}
	},
	methods: {
		...mapActions('groups', [
			'updateGroup',
		]),
		...mapActions('files', {
			imageUpload: 'upload'
		}),
		showBackgroundImageDialog() {
			this.$refs['background-image-dialog'].showDialog()
		},
		async setBackgroundImage(img) {
			this.sending = true
			let backgroundImage = {
					type: 'image',
					for: 'group_background',
					file: encodeURIComponent(img)
				},
				imageResponse = await this.imageUpload(backgroundImage)



			if (imageResponse.success) {
				let p = {
					id: this.group.id,
					name: this.group.name,
					is_join_allowed: this.group.is_join_allowed,
					is_invitations_allowed: this.group.is_invitations_allowed,
					is_public: this.group.is_public,
					background_token: imageResponse.token
				}
				if(!this.group.is_public) {
					p.is_hide = this.group.is_hide;
				}
				await this.updateGroup({ params : p })
			}
			this.sending = false
		}
	}
}
</script>

<style lang="scss">
.group-background {
	height: 180px;
	position: relative;
	overflow: hidden;
	&::before {
		background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.86) 114%);
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		bottom: 0;
		content: "";
		z-index: 1;
	}
	.group-background-image {
		position: absolute;
		min-width: 100%;
		min-height: 100%;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}
}
</style>
